import TweenMax from 'gsap';
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
//import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

import Splitting from "splitting";

//import 'imports-loader?define=>false!gsap/src/uncompressed/plugins/CSSRulePlugin';
import Fake3dEffect from './js/vendors/fake3deffect.js';


import { setupProductModal } from './js/product-modal';

if ( process.env.NODE_ENV == "production" ) {
	require( "./scss/main-production.scss" );
} else {
	require( "./scss/main-development.scss" );
}





var F20 = window.F20 || {};
F20.settings = F20.settings || {};


F20.settings = {
	"isDevice": false,
	"isApp": false,
	"isIE": false,
	"isIOS":false,
	"parallaxEnabled": true,
	"scrollMagicController": false,
	"scrollMagicDesktopController":false,
	"sectionCount": 0, //keeps track of how many times scrolling changed pages, resets with other nav
	"sectionId":{'women-01':'womens-rain','women-02':'womens-cold','women-03':'womens-wind','men-01':'mens-rain','men-02':'mens-cold','men-03':'mens-wind'},
};


( function ( $ ) {//on Arc stage they somehow kill $ reference




	

	// Common
	F20.common = {

		"init"() {


			//don't let the browser scroll save previous position when refreshing or using back buttons
			//history.scrollRestoration = "manual";


			const deviceAgent = navigator.userAgent.toLowerCase();
			const matchDevice = ( deviceAgent.match( /(iphone|ipod|ipad)/ )
			|| deviceAgent.match( /(android)/ )
			|| deviceAgent.match( /(iemobile)/ )
			|| deviceAgent.match( /iphone/i )
			|| deviceAgent.match( /ipad/i )
			|| deviceAgent.match( /ipod/i )
			|| deviceAgent.match( /blackberry/i )
			|| deviceAgent.match( /bada/i ) );


			const isIE = deviceAgent.match( /(msie|trident)/ );

			if ( isIE ) {
				F20.settings.isIE = true;
			}

			const isIOS = deviceAgent.match( /(iphone|ipod|ipad)/ );

			if (isIOS) {
				F20.settings.isIOS = true;
			}

			//var msie = window.document.documentMode;//equals 11 on IE11, undefined on other browsers

			F20.settings.isDevice = Boolean( matchDevice );

			const matchApp = deviceAgent.match( /(mobileappv2)/ );
			F20.settings.isApp = Boolean( matchApp );



			//if ($("#mobile-sized").is(":visible")){
				if ($(".slick-photo-group").length > 0){
					
					$('.slick-photo-group').on('init', function(event, slick){
						//console.log("slick",slick);
						slick.$dots.find("li:eq(0)").addClass('selected');
					});

					// On before slide change
					$('.slick-photo-group').on('beforeChange', function(event, slick, currentSlide, nextSlide){
						
						
						//$(this).find("canvas").remove();

//console.log('slick-webgl',$(this).find(".slick-slide:eq("+nextSlide+") .photo--webgl"),$(this).find(".slick-current .photo--webgl"));




						//slick.$dots.find("li:eq(0)").addClass('selected');
						if (currentSlide === 1){
						 // slick.$dots.find("li:eq(1)").addClass('selected');
						}
						if (currentSlide < nextSlide){
							//left to right
							slick.$dots.find("li:eq("+nextSlide+")").addClass('selected--right');
							if (nextSlide === 2){//fix for skipping middle slide with dot nav
								slick.$dots.find("li:eq(1)").addClass('selected--right'); 
							}
						}
						if (currentSlide > nextSlide){
							//right to left
							slick.$dots.find("li:eq("+currentSlide+")").removeClass('selected--right');
							//slick.$dots.find("li:eq("+nextSlide+")").removeClass('selected--right');
							if (nextSlide === 0){//fix for skipping middle slide with dot nav
								slick.$dots.find("li:eq(1)").removeClass('selected--right'); 
							}
						}

						//console.log(currentSlide,nextSlide);
					});



					$(".slick-photo-group").slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite:false,
						adaptiveHeight:false,
						dots: true,
						arrows:false,
						centerMode: true,
						centerPadding: 0,
						focusOnSelect: true,
						speed:200,
					});

				}
			//}


		//setup text to animate with wave
		$(".indicate-icon-title").each(function(index){

			//indicate-icon-title
		})


		//sets up text on each shop tag
		Splitting();
		/*
		if (!$("#mobile-sized").is(":visible")){
			$(that.refs.slick).slick("unslick");
		}*/





		},

	};





	F20.videoBackgroundSetup = function(){

		if (F20.settings.isApp === false){

			var currentScreenWidth = 'desktop';

			if ($("#tablet-sized").is(":visible")){
				//console.log('tablet sized');
				currentScreenWidth = 'tablet';
			}else if ($("#mobile-sized").is(":visible")){
				//console.log('mobile sized');
				currentScreenWidth = 'mobile';
			}

			//only loop what's visible
			$(".video-loop-container").each(function(index){

				var $that = $(this);
				var videoName = $that.data("video");


				var currentSection = 'mens';
				

				if ($("#lookbook").attr('class').indexOf('women') !== -1){
					currentSection = 'womens';
				}

				//console.log('currentSection',currentSection);

				var videoLoopSrc = 'https://images.arcteryx.com/campaign/F20/winter-lookbook/video' + '/' + videoName;
				/*
						<source src="${videoLoopSrc}.webm" type="video/webm">*/
				var videoHtml = `<video preload="auto" autoplay loop muted playsinline>
						<source src="${videoLoopSrc}.mp4" type="video/mp4">
					</video>`;

				setTimeout(function(){

					$that.html(videoHtml);

				},index * 5000)

			});

		}



	}



	F20.addHandlers = function () {



		//flip between mens/womens in the flyout nav
		$( ".desktop .nav-panel__selection" )
			.hover( function () {
				F20.goToNavSection(this);
			} );

		$( ".device .nav-panel__selection" )
				.click(function (e) {
						if (!$(this).hasClass("selected")) {
								e.stopPropagation();
								F20.goToNavSection(this);
						}
			} );



		$(".layout__home .background-panel__content-nav a").click(function(){
			var section = $(this).data('section');
			F20.trackPropEvent("prop70", "eVar70", 'navHeroHome: LinkClick : shop_'+section);
		})


		$(".layout__mens .sub-nav").click(function(){
			var section = $(this).data('section');
			F20.trackPropEvent("prop70", "eVar70", 'nav: ScrollClick : mens '+section);
		})

		$(".layout__womens .sub-nav").click(function(){
			var section = $(this).data('section');
			F20.trackPropEvent("prop70", "eVar70", 'nav: ScrollClick : womens '+section);
		})


		$(".layout__womens .panel-text-cta").click(function(){
			var section = $(this).data('section');
			F20.trackPropEvent("prop70", "eVar70", 'ShopCta: LinkButton : womens '+section);
		})

		$(".layout__mens .panel-text-cta").click(function(){
			var section = $(this).data('section');
			F20.trackPropEvent("prop70", "eVar70", 'ShopCta: LinkButton : mens '+section);
		})

		

		//click the background or title in a section of the flyout nav
		$( ".nav-panel__section" ).click(function () {


			F20.settings.sectionCount = 0;

			const sectionSelected = $( this )
				.find( ".nav-panel__selection.selected" )
				.data( "section" );

			F20.changeSection(sectionSelected);

			//F20.settings.sectionId[sectionSelected] == womens-cold
			//sectionSelected  == women-02

			F20.trackPropEvent("prop70", "eVar70", 'navPanelClick:' + sectionSelected);

						
		} );











		$(".sub-nav").click(function(){

			var targetId = '#' + $(this).data('section');

			var destination = $(targetId).offset().top;
            
            $("body,html").animate({scrollTop: destination}, 500);
            
            return false;

		})

			




	};



	F20.goToNavSection = function (that) {
			//change the background section in the flyout nav

					//const sectionSelected = $( that ).data( "section" );
					const index = $(that).index();

					$(that)
							.parent()
							.parent()
							.find(".selected")
							.removeClass("selected");
					$(that)
							.addClass("selected");

					$(that)
							.parent()
							.parent()
							.find(`.nav-panel__background:eq(${index - 1})`)
							.addClass("selected");

					//F20.changeSection( sectionSelected );

	};
		

	F20.changeSection = function(sectionId){
		//console.log('sectionId',sectionId);

		if (sectionId.indexOf('women') !== -1){

			window.location.href = '/shop/winter-lookbook/womens/' + '#' + sectionId;
		}else{
			window.location.href = '/shop/winter-lookbook/mens/' + '#' + sectionId;
		}
		
		
	}

	
	F20.elementSetup = function () {
		if ( F20.settings.isDevice ) {
			$( "body" )
				.addClass( "device" );
		} else {
			$( "body" )
				.addClass( "desktop" );
		}
		if ( F20.settings.isApp ) {
			$( "body" )
				.addClass( "app" );
		}

		//console.log('add body IE class',F20.settings.isIE);
		if ( F20.settings.isIE ) {
			//setTimeout(function(){
				$( "#content" ).addClass( "ie" );

			//},500)
			}
			if (F20.settings.isIOS) {
					$("#content").addClass("ios");
			}

		if ( $( "#mobile-sized" )
			.is( ":visible" ) || F20.settings.isDevice ) {
			F20.settings.parallaxEnabled = false;
		} else {
			F20.settings.parallaxEnabled = true;
		}


		if ( ARCTERYX.WEBSITE_SETTINGS.COUNTRY == "JP" ){
			$(".jp-hidden").hide();
		}


		if (!F20.settings.isIE && $('.gl3d').length > 0){

			var gl3dElement = $('.gl3d')[0];
			new Fake3dEffect(gl3dElement);

		}



		$( ".rollover-alternate" ).each(function (index) {

			
			var $that = $(this);
			var timerOffset = 0;

			timerOffset = Math.floor(Math.random() * (2700 - 1));
/*
			if ( index % 2 ){
				timerOffset = 900;
			}else if ( index % 3 ){
				timerOffset = 1800;
			}
*/
			setTimeout(function(){

				var counter = $that.find(".photo").length;
				var totalImgs = counter;

				if ($that.find(".current").index() > 0){
					counter = $that.find(".current").index();
				}


				$that.find(".photo").removeClass('current');
				$that.find(".hover"+counter).addClass("current");

			
				setInterval(function () {
					
					
					if (counter == totalImgs + 1){
						counter = 1;
					}


					$that.find(".photo").removeClass('current');

					$that.find(".hover"+counter).addClass("current");

					counter++;


				},2700);


			},timerOffset)
			

		});



	};

	F20.resetScrollMagic = function () {
		// If(!F20.settings.parallaxEnabled){
		if ( typeof F20.settings.scrollMagicController === "object" ) {
			F20.settings.scrollMagicController.destroy( true );
			F20.settings.scrollMagicController = false;
		}

		if ( typeof F20.settings.scrollMagicDesktopController === "object" ) {
			F20.settings.scrollMagicDesktopController.destroy( true );
			F20.settings.scrollMagicDesktopController = false;
		}


		$(".background-panel__button .title").css("opacity","1");
			/*

			$( ".panel" )
				.each( function () {
					TweenMax.set( $( this, ".full-panel__bg", ".background-panel__content" ), { "clearProps": "all" } );
				} );
			*/

			TweenMax.set( $(".background-panel__content, .c-breadcrumbs" ), { "clearProps": "all" } );

		// }
	};


	F20.addScrollMagic = function () {

		//always active version all devices
		//if ( F20.settings.parallaxEnabled ) {
			if ( typeof F20.settings.scrollMagicController !== "object" ) {
				// Init controller
				F20.settings.scrollMagicController = new ScrollMagic.Controller();

					/*
					if (!F20.settings.isIE){


						$('.gl3d').each( function () {
							const $currentTrigger = $( this );


							new ScrollMagic.Scene( {
								"triggerElement": $currentTrigger[0],
								"duration": '200%',
							} )
								.on( "enter", (event) => {

									//enter triggered multiple times on resize so remove extra canvas
									$currentTrigger.find("canvas").remove();

									var gl3dElement = $currentTrigger[0];
									new Fake3dEffect(gl3dElement);


								} )
								.on( "leave", (event) => {


									//$currentTrigger.data("webglhover").destroy();
									$currentTrigger.find("canvas").remove();

								} )

								.triggerHook( 1 )
							// .addIndicators()
								.addTo( F20.settings.scrollMagicController );
						});


					}
					*/


					$(".rollover-tag--slideshow").each( function () {
						const $currentTrigger = $( this );


						new ScrollMagic.Scene( {
							"triggerElement": $currentTrigger[0],
							"duration": '100%',
						} )
							.on( "enter", (event) => {

								$currentTrigger.removeClass('active');


								$currentTrigger.addClass('active');

								setTimeout(function(){
									$currentTrigger.removeClass('active');
								},5000);


							} )
							.triggerHook( 0.25 )
						// .addIndicators()
							.addTo( F20.settings.scrollMagicController );
					});




					$("#lookbook").each( function () {
						const $currentTrigger = $( this );
						const headerHeight = $(".header-container").height();

						//setup with top free shipping banner
						if (!$("body").hasClass("nav-open")){
						if ($("#mobile-sized").is(":visible")){
							$(".nav-burger").css("top",headerHeight + 35);
						}
						}


						new ScrollMagic.Scene( {
							"triggerElement": $currentTrigger[0],

						} )
							.on( "enter", (event) => {


								if (!$("body").hasClass("nav-open")){

									$(".nav-burger").attr("style","");

								}
								



							} )
							.on( "leave", (event) => {

								if (!$("body").hasClass("nav-open")){
								if ($("#mobile-sized").is(":visible")){
									$(".nav-burger").css("top",headerHeight + 35);
								}
								}


							} )
							.triggerHook( 0 )
						// .addIndicators()
							.addTo( F20.settings.scrollMagicController );
						});

/*

					$(".current .section-container .section-changer")
						.not(":last").addClass('fadein')
						.each( function () {
						const $currentTrigger = $( this );

						const nextSection = $currentTrigger.data("next");
						//console.log('$currentTrigger',$currentTrigger,nextSection);


						new ScrollMagic.Scene( {
							"triggerElement": $currentTrigger[0],
							"duration": '100%',
						} )
							.on( "enter", (event) => {
								if (event.scrollDirection == 'FORWARD'){
										F20.settings.sectionCount++;
												$currentTrigger.removeClass('fadein');
										if (F20.settings.sectionCount > 1 && F20.settings.sectionCount < 4){
											//$currentTrigger.removeClass("selected").find(nextSection).addClass( "selected" );
											F20.changeSection(F20.settings.sectionId[nextSection], 'navScroll');
											//console.log('Scroll change section');

										}
								}
									console.log('scroll sectionCount', F20.settings.sectionCount, $currentTrigger.offset().top, $("#womens-rain").offset().top );
							} )
							.triggerHook( 0.75 )
						// .addIndicators()
							.addTo( F20.settings.scrollMagicController );
						});
*/


					$(".current .section-container")
						.not(".section-container--footer")
						.each(function (index) {

//console.log('index',index);
							var $currentTrigger = $(this);
							var progressvalue = 0;

							var currentProgressBar = index + 1;
							if (currentProgressBar>3){
								currentProgressBar = currentProgressBar - 3;
							}

							let sectionSelected = $currentTrigger.attr("id");
							let sectionClassName = Object.keys(F20.settings.sectionId).find(key => F20.settings.sectionId[key] === sectionSelected);

							//console.log('$currentTrigger.height() , $(window).height()',$currentTrigger.height(),$(window).height());


//<div class="nav-burger__line nav-burger__line--1"><div class="nav-burger__inner-line"></div></div>



							new ScrollMagic.Scene({
									triggerElement: $currentTrigger[0],
									duration: $currentTrigger.height() - $(".header-container").height(),
									offset: $(".header-container").height() * -1 - 1
							})
									.on("progress", function (e) {
											progressvalue = Math.floor(100 * e.progress);
											//console.log(progressvalue);

											if (progressvalue > 99) {
													//hidden on nav change instead
													//$('.nav-bar__line').addClass("hidden");
											} else {

													$(".nav-bar > div, .nav-panel__transition > div, #lookbook")
															.attr("class", "")
															.addClass(sectionClassName);

													$('.nav-bar__line').removeClass("hidden");

											}
											$('.nav-burger__line--'+currentProgressBar+' .nav-burger__inner-line').css('width', progressvalue + "%");
									})
									.triggerHook(0)
									//.addIndicators()
									//.setTween(tweenImage)
									.addTo(F20.settings.scrollMagicController);


					})
					/*
					$(".current .section-container--footer")
						.each(function (index) {

//console.log('index',index);
							var $currentTrigger = $(this);

							new ScrollMagic.Scene({
									triggerElement: $currentTrigger[0],
									duration: 0
							})
									.on("enter", function (e) {
										//$(".nav-bar,.nav-burger,.nav-bar__title").hide();
									})
									.on("leave", function (e) {
										//$(".nav-bar,.nav-burger,.nav-bar__title").show();
									})
									.triggerHook(1)
									//.addIndicators()
									//.setTween(tweenImage)
									.addTo(F20.settings.scrollMagicController);


					})
					*/


			}
		//}

		//do the DESKTOP version
		if ( F20.settings.parallaxEnabled ) {
			if ( typeof F20.settings.scrollMagicDesktopController !== "object" ) {
				// Init controller
				F20.settings.scrollMagicDesktopController = new ScrollMagic.Controller();


				/*
				 * If ($(".hero.lifestyle").length > 0){
				 *
				 * var tLifestyleHero = new TimelineMax()
				 * .to($(".hero.lifestyle .content")[0], 1, {y:'+=200',opacity:0, ease:Linear.easeInOut})
				 *
				 *
				 * new ScrollMagic.Scene({
				 * triggerElement: $(".hero.lifestyle")[0],
				 * duration:'100%'
				 *
				 * })
				 * //.addIndicators() // add indicators (requires plugin)
				 * .triggerHook(0)
				 * .setTween(tLifestyleHero)
				 * .addTo(F20.settings.scrollMagicController);
				 *}
				 */
//console.log('init scrollmagic');

					$( ".current .section-container .panel" )
					.not( ".panel .panel" )
					.each( function () {
						const currentTrigger = $( this )[0];
						const currentDuration = "50%";// $(this).height()/2;

						const tweenImage = new TimelineMax()
							.fromTo( $( this ), 1, { "opacity": 0 }, { "opacity": 1, "ease": Linear.easeOut }, 0 );

						new ScrollMagic.Scene( {
							"triggerElement": currentTrigger,
							"duration": currentDuration,
						} )
							.triggerHook( 1 )
						// .addIndicators()
							.setTween( tweenImage )
							.addTo( F20.settings.scrollMagicDesktopController );
					} );


					$(".current .section-container .pinned-container").each(function(){
						//move inner __bg downward if parent panel height is greater
						var $that = $(this);
						var currentTrigger = $that[0];
						var $backgroundImage = $that.find(".full-panel__bg");
						var $backgroundContent = $that.find(".background-panel__content");
						var $breadCrumbContent = $that.find(".c-breadcrumbs");

						var coverAnimation = new TimelineMax()
							//.set($that, {overflow:"hidden"})
							.to($backgroundImage, 1, {height:'0', ease:Linear.easeNone}, 0)
							.to($backgroundContent, 1, {top:-$backgroundContent.height(), "opacity": 0, ease:Linear.easeNone}, 0)
							.to($breadCrumbContent, 1, {top:-$backgroundContent.height(), ease:Linear.easeNone}, 0);

						// create scene to pin and link animation
						new ScrollMagic.Scene({
								triggerElement: currentTrigger,
								triggerHook: 0,
								//offset:50,
								duration: $that.height(),
							})
							.setTween(coverAnimation)
							.setPin(currentTrigger, {pushFollowers: false})
							.addTo(F20.settings.scrollMagicDesktopController);
					});




					$(".current .panel-text").each(function(){

						var $currentTrigger = $(this);
						var tweenElement = $(this)[0];

						var tImage = new TimelineMax()
						.fromTo(tweenElement, 1, {opacity:0},{opacity:1, ease:Linear.easeInOut},0);
						//.fromTo(tweenElement, 1, {y:'-=100'},{y:'+=100', ease:Linear.easeInOut},0);

						new ScrollMagic.Scene({
							triggerElement: $currentTrigger[0],
							//duration: $currentTrigger.height(),
							duration: 0,
						})


						.triggerHook(.7)
						//.addIndicators()
						.setTween(tImage)
						.addTo(F20.settings.scrollMagicDesktopController);

					})




					$(".background-panel__button").each(function(){

						$(".background-panel__button .title").css("opacity","0");

						var $currentTrigger = $(this);

						new ScrollMagic.Scene( {
							"triggerElement": $currentTrigger[0],

						} )
							.on( "enter", (event) => {

								$currentTrigger.addClass('scrolled');
								$currentTrigger.find(".title").css("opacity","1");

							} )
							.on( "leave", (event) => {

								$currentTrigger.removeClass('scrolled');
								$currentTrigger.find(".title").css("opacity","0");

							} )


						.triggerHook(.7)

						.addTo(F20.settings.scrollMagicDesktopController);

					})
					





					$(".current .photo-group .photo").not(".photo .photo").each(function(){

						var $currentTrigger = $(this);
						var tweenElement = $(this)[0];

						$(this).addClass('fadein');

						/*
						var tImage = new TimelineMax()
						//.fromTo(rule, {tweenElement, 1, {backgroundPositionY:0},{backgroundPositionY:'-50px', ease:Linear.easeInOut},0);
						.to(tweenElement, 1, {y:'+=50px',marginBottom:'+=50px',height:'-=50px', ease:Linear.easeInOut},0);

						new ScrollMagic.Scene({
							triggerElement: $currentTrigger[0],
							duration: $currentTrigger.height(),
						})


						.triggerHook(0)
						//.addIndicators()
						.setTween(tImage)
						.addTo(F20.settings.scrollMagicDesktopController);
						*/




						//var tImage2 = new TimelineMax()
						//.fromTo(rule, {tweenElement, 1, {backgroundPositionY:0},{backgroundPositionY:'-50px', ease:Linear.easeInOut},0);
						//.from(tweenElement, 1, {y:'+=100px',opacity:0, ease:Linear.easeInOut},0);

						new ScrollMagic.Scene({
							triggerElement: $currentTrigger[0],
							duration: $currentTrigger.height(),
						})

						.on("enter",function(){
							$currentTrigger.removeClass("fadein");
						})

						.triggerHook(.7)
						//.addIndicators()
						//.setTween(tImage2)
						.addTo(F20.settings.scrollMagicDesktopController);


					})




			}
		}
	};


	F20.trackPropEvent = function( prop, eVar, eventString ) {
	
		const propObject = {};
		const eVarObject = {};

		propObject[prop] = eventString;
		eVarObject[eVar] = eventString;

			eVarObject['eVar3'] = window.location.href;
		 console.log('propObject', propObject);
		 console.log('eVarObject', eVarObject);


		ARCTERYX.analytics.trackEvent( {
			"category": "f20-winter-lookbook",
			"action": "",
			"label": eventString,
			"props": propObject,
			"eVars": eVarObject,
		} );
};



	F20.windowResize = function () {
		F20.resetScrollMagic();
		// SetTimeout(function(){
		//F20.elementSetup();
		F20.addScrollMagic();

		F20.videoBackgroundSetup();

		// },15000);
	};





	$( document )
		.ready( () => {
			F20.common.init();

			F20.elementSetup();

			//setup in section change
			//F20.videoBackgroundSetup();

			setupProductModal();//export from product-modal.js

			F20.addHandlers();

			F20.addScrollMagic();

			F20.videoBackgroundSetup();

		} );

}( jQuery ) );

jQuery( window )
	.resize( () => {
	// Slow down functions called on resize
		clearTimeout( F20.resizer );
		F20.resizer = setTimeout( F20.windowResize, 150 );
	});


$(window).bind("pageshow", function (event) {
/*
Initially loading the page
Navigating to the page from another page in the same window or tab
Restoring a frozen page on mobile OSes
Returning to the page using the browser's forward or back buttons
*/
console.log('pageshow changeAction',event);


		if (event.originalEvent.persisted) {
			//console.log('event persisted changeAction');
			window.location.reload();
		}
});

/*
 * JQuery(window).on('load', function(){
 *
 * });
 */

if ( window.addEventListener ) {
	window.addEventListener( "orientationchange", F20.windowResize, false );

	window.addEventListener('popstate', function (event) {
		console.log('popstate listener changeAction');
		if (history.state && history.state.id) {
				F20.changeSection(history.state.id,'browserButton');
		}
	}, false);
}